import { createContext } from "react";
import { useState, useRef } from "react";


export const VideoContext = createContext(null);



export const VideoProvider = ({ children }) => {

    const playerRefs = useRef([]);
    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

    const handlePlay = (index) => {
        if (currentPlayingIndex !== null) {
            // Pause the currently playing video
            pauseVideo(currentPlayingIndex);
        }

        playVideo(index);
    };

    const playVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'play',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(index);
        }
    };

    const pauseVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'pause',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(null);
        }
    };






    return (
        <VideoContext.Provider value={{ currentPlayingIndex, setCurrentPlayingIndex, handlePlay, playVideo, pauseVideo, playerRefs }}>
            {children}
        </VideoContext.Provider>
    );
}